import { IAccessScope, ITenant } from '../../../../reducers/Reducers.interfaces'
import { IActionCreatorAsync } from '../../../../core/actions/Actions.interfaces'

export enum EditingTypes {
    SSO_SAML = 'sso-saml',
    OIDC = 'oidc',
    TFA = 'tfa',
    PASSWORD_ONLY = 'password-only',
    SCIM_PROVISIONING = 'scim-provisioning'
}

export interface SignInMethodsProps {
    accessScope?: IAccessScope
    account: ITenant
    canEdit : boolean
    canEditSCIM?: boolean
}

export interface SignInMfaDispatchProps {
    enableMfa: IActionCreatorAsync
    fetchTenantById: IActionCreatorAsync
    editStandardSignIn: IActionCreatorAsync
    getAccountSignIn: IActionCreatorAsync
    setAccount: (any) => void
    updateClientAuthCertLogin: IActionCreatorAsync
    updateClientAuthCert1FA: IActionCreatorAsync
    getSCIMConfig: IActionCreatorAsync
    fetchFeatureFlag: IActionCreatorAsync
}

export type ExtendedSignInMethodsProps = SignInMethodsProps & SignInMfaDispatchProps
